import React from "react";
import { Button, ScrollView } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import "./employee-home.scss"
import DashboardMyLeave from "../../dasboard-cards/dashboard-my-leave/dashboardMyLeave";
import MuiDashboard from "../../mui-dashboard/mui-dashboard";


function EmployeeHome() {
    const navigate = useNavigate();

    return (

        <ScrollView className='view-wrapper-scroll'>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    {/* <Button onClick={() => navigate('/leave-request')} text="İzin Talep"></Button>
                    <Button onClick={() => navigate('/approve-hierarchy-list')} text="Approve Hierarchy List"></Button>
                    <Button onClick={() => navigate('/employee-document-info-list')} text="Employee Document Info List"></Button> */}
                    <Button onClick={() => navigate('/employee-document-approval')} text="Employee Document Approval"></Button>
                    <Button onClick={() => navigate('/approval-request-list')} text="Approval Request List"></Button>
                </div>
            </div>

            {/* <div className='cards compact'>
                <DashboardMyLeave />
                
                <div className="card">

                </div>
                <div className="card">

                </div>
                <div className="card">

                </div>
            </div>
            <div className='cards normal'>
                <div className="card">

                </div>
                <div className="card">

                </div>
            </div> */}
        </ScrollView>

    )
    // return (
    //     <React.Fragment>
    //         <div className={'content-block'}>
    //             <div className={'dx-card responsive-paddings'}>
    //                 <Button onClick={() => navigate('/leave-request')} text="İzin Talep"></Button>
    //                 <Button onClick={() => navigate('/approve-hierarchy-list')} text="Approve Hierarchy List"></Button>
    //             </div>
    //         </div>

    //     </React.Fragment>
    // )

}

export default EmployeeHome